import { Trans, useTranslation } from 'next-i18next';

import { V1A_NAMESPACE } from '../constants';
import { MultiInternet } from '../multi-internet';
import { Multiconexao } from '../multiconexao';

export function Tech() {
  const { t } = useTranslation(V1A_NAMESPACE);

  return (
    <section className='v1-tech relative isolate overflow-x-clip bg-[linear-gradient(180deg,#0B0D10,#0E1116_40%,#0B0D10)] py-[clamp(3rem,1.5rem_+_5vw,6rem)]' aria-labelledby='v1-tech-title'>
      <div className='v1-tech__bg' aria-hidden='true' />
      <div className='v1-tech__head mx-auto w-full max-w-[90rem] px-[var(--gutter)] text-center [&_.v1-h2]:mx-auto [&_.v1-h2]:max-w-[20ch] [&_.v1-lead]:mx-auto'>
        <p className='v1-eyebrow m-0 inline-flex items-center gap-2 text-[length:var(--t-micro)] font-semibold uppercase leading-[1.3] tracking-[.16em] text-[#9AA3B5]' data-reveal=''>
          <span className='v1-eyebrow__dot size-1.5 flex-none rounded-full bg-[#93FF18] shadow-[0_0_10px_rgb(147_255_24/.8)]' aria-hidden='true' />
          {t('tech.eyebrow')}
        </p>
        <h2 className='v1-h2 mt-3 text-balance text-[length:var(--t-h2)] font-bold leading-[1.04] tracking-[-.032em] text-[#FFFFFF] min-[1920px]:text-[length:3.5rem]' id='v1-tech-title' data-reveal=''>
          <Trans t={t} i18nKey='tech.title' components={{ hl: <span className='v1-hl !text-[#93FF18] [text-shadow:0_0_22px_rgb(147_255_24/.3)] forced-colors:!text-[LinkText]' /> }} />
        </h2>
        <p className='v1-lead mt-4 max-w-[44rem] text-pretty text-[length:var(--t-lead)] leading-[1.55] text-[#CBD5E1]' data-reveal=''>
          {t('tech.lead')}
        </p>
      </div>

      <Multiconexao />
      <MultiInternet />
    </section>
  );
}
